export interface GeoJSONGeometry {
  type: string;
  coordinates?: unknown;
  geometries?: GeoJSONGeometry[];
}

export interface RascunhoFeicao {
  id: string;
  projetoId: string;
  quadraId: string | null;
  projetoRefId: number | null;
  quadraRefId: number | null;
  areaPilotoRefId: number | null;
  camadaDestino: string;
  tipoObjeto: string;
  tipoGeometria: string;
  geom: GeoJSONGeometry | null;
  propriedades: Record<string, unknown>;
  status: RascunhoStatus;
  fonte: string;
  validacao: string;
  areaM2: number | null;
  comprimentoM: number | null;
  perimetroM: number | null;
  publicadoSchema: string | null;
  publicadoTabela: string | null;
  publicadoId: string | null;
  criadoPor: string | null;
  revisadoPor: string | null;
  aprovadoPor: string | null;
  publicadoPor: string | null;
  criadoEm: string;
  atualizadoEm: string;
  revisadoEm: string | null;
  aprovadoEm: string | null;
  publicadoEm: string | null;
}

export type RascunhoStatus =
  | "RASCUNHO"
  | "EM_REVISAO"
  | "AJUSTAR"
  | "APROVADO"
  | "PUBLICADO"
  | "REJEITADO"
  | "CANCELADO";

export interface CamadaGeo {
  id: string;
  nome: string;
  schemaName: string;
  tableName: string;
  camadaDestino: string;
  tipoObjeto: string;
  tipoGeometria: string;
  descricao: string | null;
  status: string;
}

export interface CamadaFeature {
  id: string;
  rascunhoId: string | null;
  quadraId: string | null;
  geom: GeoJSONGeometry | null;
  propriedades: Record<string, unknown>;
  fonte: string;
  validacao: string;
  publicadoEm: string;
}

export interface RascunhoPublishResult {
  rascunhoId: string;
  camadaDestino: string;
  publicadoId: string;
  objetoTerritorialId: string;
  status: string;
}

export interface CamadaPerfil {
  label: string;
  camadaDestino: string;
  tipoObjeto: string;
  tipoGeometria: "POINT" | "MULTIPOLYGON" | "MULTILINESTRING" | "GEOMETRY";
  disponivel: boolean;
}

export const CAMADA_PERFIS: CamadaPerfil[] = [
  { label: "Árvore ponto", camadaDestino: "geo.arvores_pontos", tipoObjeto: "ARVORE", tipoGeometria: "POINT", disponivel: true },
  { label: "Copa de árvore", camadaDestino: "geo.arvores_copas", tipoObjeto: "COPA_ARVORE", tipoGeometria: "MULTIPOLYGON", disponivel: true },
  { label: "Poste", camadaDestino: "geo.postes", tipoObjeto: "POSTE", tipoGeometria: "POINT", disponivel: true },
  { label: "Fiação", camadaDestino: "geo.fiacao", tipoObjeto: "FIACAO", tipoGeometria: "MULTILINESTRING", disponivel: true },
  { label: "Calçada", camadaDestino: "geo.calcadas", tipoObjeto: "CALCADA", tipoGeometria: "MULTIPOLYGON", disponivel: true },
  { label: "Área gramada", camadaDestino: "geo.areas_gramadas", tipoObjeto: "AREA_GRAMADA", tipoGeometria: "MULTIPOLYGON", disponivel: true },
  { label: "Área verde", camadaDestino: "geo.areas_verdes", tipoObjeto: "AREA_VERDE", tipoGeometria: "MULTIPOLYGON", disponivel: true },
  { label: "Interferência urbana", camadaDestino: "geo.interferencias", tipoObjeto: "INTERFERENCIA", tipoGeometria: "GEOMETRY", disponivel: true },
  { label: "Canteiro", camadaDestino: "geo.canteiros", tipoObjeto: "CANTEIRO", tipoGeometria: "MULTIPOLYGON", disponivel: false },
  { label: "Lote", camadaDestino: "geo.lotes", tipoObjeto: "LOTE", tipoGeometria: "MULTIPOLYGON", disponivel: false },
  { label: "Quadra", camadaDestino: "geo.quadras", tipoObjeto: "QUADRA", tipoGeometria: "MULTIPOLYGON", disponivel: false },
];

export const STATUS_LABELS: Record<RascunhoStatus, string> = {
  RASCUNHO: "Rascunho",
  EM_REVISAO: "Em revisão",
  AJUSTAR: "Ajustar",
  APROVADO: "Aprovado",
  PUBLICADO: "Publicado",
  REJEITADO: "Rejeitado",
  CANCELADO: "Cancelado",
};

export const STATUS_TONES: Record<RascunhoStatus, "neutral" | "info" | "warning" | "success" | "danger"> = {
  RASCUNHO: "neutral",
  EM_REVISAO: "info",
  AJUSTAR: "warning",
  APROVADO: "success",
  PUBLICADO: "success",
  REJEITADO: "danger",
  CANCELADO: "neutral",
};
